import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { postLead, trackEvent } from '../lib/leads';
import { waLink, DEFAULT_WA_MESSAGE } from '../lib/whatsapp';
import LegalModal from './LegalModal';

function FooterCtaBlock({ openLegal }) {
  const [form, setForm] = useState({ name: '', phone: '', email: '' });
  const [agree, setAgree] = useState(false);
  const [status, setStatus] = useState('idle'); // idle | sending | ok | err
  const [err, setErr] = useState('');

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!agree) {
      setErr('Confirma que aceptas recibir información para continuar.');
      return;
    }
    if (!form.name.trim() || !form.phone.trim() || !form.email.trim()) {
      setErr('Completa todos los campos.');
      return;
    }
    setErr('');
    setStatus('sending');
    const res = await postLead('visit', {
      name: form.name.trim(),
      email: form.email.trim(),
      phone: form.phone.trim(),
      source_page: 'footer-contact-form',
    });
    if (res.ok) {
      setStatus('ok');
      trackEvent('footer_form_submitted', { email: form.email.trim() });
      setForm({ name: '', phone: '', email: '' });
      setAgree(false);
    } else {
      setStatus('err');
      setErr(res.error || 'No se pudo enviar. Intenta otra vez o por WhatsApp.');
    }
  };

  return (
    <div className="footer-cta-block" data-testid="footer-cta-block">
      <div className="footer-cta-left">
        <div className="text-label" style={{ color: 'var(--color-two, #f6802c)', marginBottom: '0.75rem' }}>
          ¿hablamos?
        </div>
        <h2 className="sm-h2" style={{ marginBottom: '0.85rem' }}>
          Haz realidad el hogar de <span className="serif-accent">tus sueños.</span>
        </h2>
        <p className="text-size-medium" style={{ maxWidth: '460px' }}>
          Déjanos tus datos y un asesor te contacta hoy mismo, o márcanos directo.
        </p>
        <div className="footer-cta-buttons" data-testid="footer-cta-buttons">
          <a href="tel:5567911796" className="footer-cta-btn footer-cta-call" data-testid="footer-cta-call">
            <span className="icon-font">call</span>
            <span>Llámanos</span>
          </a>
          <a
            href={waLink(DEFAULT_WA_MESSAGE)}
            target="_blank"
            rel="noopener noreferrer"
            className="footer-cta-btn footer-cta-whatsapp"
            data-testid="footer-cta-whatsapp"
          >
            <img loading="lazy" src="/images/whatsapp.svg" alt="WhatsApp" />
            <span>WhatsApp</span>
          </a>
        </div>
        <div className="footer-cta-trust" aria-hidden="true">
          <div>
            <strong>15 min</strong>
            <span>Respuesta promedio</span>
          </div>
          <div>
            <strong>0 spam</strong>
            <span>Solo asesoría real</span>
          </div>
          <div>
            <strong>+13 años</strong>
            <span>Construyendo vivienda</span>
          </div>
        </div>
      </div>

      <div className="footer-cta-right">
        {status === 'ok' ? (
          <div className="footer-form-success" data-testid="footer-form-success">
            <div className="footer-form-success-icon">
              <span className="icon-font">check_circle</span>
            </div>
            <h3>¡Gracias por contactarnos!</h3>
            <p>Tu mensaje ya está con nuestro equipo. Te llamamos en menos de 15 minutos en horario hábil.</p>
            <button
              type="button"
              className="footer-form-reset"
              onClick={() => setStatus('idle')}
              data-testid="footer-form-reset"
            >
              Enviar otro mensaje
            </button>
          </div>
        ) : (
          <form className="footer-form" onSubmit={onSubmit} data-testid="footer-form" noValidate>
            <div className="footer-form-head">
              <div className="footer-form-kicker">contacto express</div>
              <h3>Solicita información</h3>
              <p>Te contactamos en menos de 15 minutos.</p>
            </div>
            <label className="footer-form-field">
              <span>Nombre completo *</span>
              <input
                type="text"
                value={form.name}
                onChange={(e) => setForm({ ...form, name: e.target.value })}
                placeholder="Nombre y apellido"
                data-testid="footer-form-name"
                required
              />
            </label>
            <label className="footer-form-field">
              <span>Teléfono móvil *</span>
              <input
                type="tel"
                value={form.phone}
                onChange={(e) => setForm({ ...form, phone: e.target.value })}
                placeholder="Incluye lada (ej. 55 1234 5678)"
                data-testid="footer-form-phone"
                required
              />
            </label>
            <label className="footer-form-field">
              <span>Email *</span>
              <input
                type="email"
                value={form.email}
                onChange={(e) => setForm({ ...form, email: e.target.value })}
                placeholder="tu@correo.com"
                data-testid="footer-form-email"
                required
              />
            </label>
            <label className="footer-form-check">
              <input
                type="checkbox"
                checked={agree}
                onChange={(e) => setAgree(e.target.checked)}
                data-testid="footer-form-consent"
              />
              <span>Acepto recibir información sobre Santa Mónica Residencial.               <button type="button" className="footer-legal-inline-btn" onClick={() => openLegal('aviso')}>Aviso de privacidad</button></span>
            </label>
            {err && <div className="footer-form-error" data-testid="footer-form-error">{err}</div>}
            <button
              type="submit"
              className="footer-form-submit"
              disabled={status === 'sending'}
              data-testid="footer-form-submit"
            >
              {status === 'sending' ? 'Enviando…' : (
                <>
                  <span>Quiero más información</span>
                  <span className="icon-font">arrow_forward</span>
                </>
              )}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}

export default function Footer() {
  const [legalOpen, setLegalOpen] = useState(false);
  const [legalTab, setLegalTab] = useState('aviso');
  const openLegal = (tab) => { setLegalTab(tab); setLegalOpen(true); };

  return (
    <footer className="footer-component" data-testid="footer">
      <div className="page-padding">
        <div className="container-large">

          {/* RICH CTA BLOCK */}
          <FooterCtaBlock openLegal={openLegal} />

          {/* MID — brand + nav */}
          <div className="footer-mid">
            <div className="footer-mid-brand">
              <Link to="/" className="footer-brand">
                <img loading="lazy" src="/images/santa-monica-residencial-white.svg" alt="Santa Mónica Residencial" />
              </Link>
              <p className="text-size-small footer-mid-tagline">
                Casas nuevas en Pachuca. Estrena un hogar diseñado para crecer con tu familia.
              </p>
              <div className="flex-social" data-testid="footer-social">
                <a href="https://www.facebook.com/SantaMonicaResidencialMx" target="_blank" rel="noopener noreferrer" className="icon-social-btn" aria-label="Facebook">
                  <img loading="lazy" src="/images/facebook.svg" alt="" />
                </a>
                <a href="https://www.instagram.com/santamonica_mx/" target="_blank" rel="noopener noreferrer" className="icon-social-btn" aria-label="Instagram">
                  <img loading="lazy" src="/images/instagram.svg" alt="" />
                </a>
                <a href="https://www.youtube.com/@quru5366" target="_blank" rel="noopener noreferrer" className="icon-social-btn youtube" aria-label="YouTube">
                  <img loading="lazy" src="/images/youtube.svg" alt="" />
                </a>
              </div>
            </div>

            <div className="footer-mid-col">
              <div className="footer-nav-title">Navega</div>
              <Link to="/modelo-fernanda" className="footer-link">Modelo Fernanda</Link>
              <Link to="/modelo-mariana" className="footer-link">Modelo Mariana</Link>
              <a href="#disponibilidad" className="footer-link">Master plan</a>
              <a href="#amenidades" className="footer-link">Amenidades</a>
              <a href="#ubicacion" className="footer-link">Ubicación</a>
              <Link to="/agendar-visita" className="footer-link">Agendar visita</Link>
            </div>

            <div className="footer-mid-col">
              <div className="footer-nav-title">Contacto</div>
              <a href="tel:5567911796" className="footer-link">+52 55 6791 1796</a>
              <a href={waLink()} target="_blank" rel="noopener noreferrer" className="footer-link">WhatsApp directo</a>
              <a href="mailto:ventas@santamonicaresidencial.mx" className="footer-link">ventas@santamonicaresidencial.mx</a>
              <span className="footer-link-soft">L–V 9:00 – 19:00 h</span>
              <span className="footer-link-soft">Sáb 10:00 – 14:00 h</span>
            </div>

            <div className="footer-mid-col">
              <img loading="lazy" src="/images/quru.svg" alt="Quru" className="quru-logo" />
              <span className="footer-link-soft">Desarrollador inmobiliario con más de 13 años de experiencia desarrollando vivienda premium en México.</span>
            </div>
          </div>

          {/* BOTTOM — legal + powered by SUARA prominent */}
          <div className="footer-bottom">
            <div className="footer-legal-text">
              <span>© {new Date().getFullYear()} Santa Mónica Residencial · Todos los derechos reservados</span>
              <Link to="/aviso-privacidad" className="footer-link-soft" onClick={(e) => { e.preventDefault(); openLegal('aviso'); }} data-testid="footer-link-aviso">Aviso de privacidad</Link>
              <Link to="/terminos" className="footer-link-soft" onClick={(e) => { e.preventDefault(); openLegal('terminos'); }} data-testid="footer-link-terminos">Términos y condiciones</Link>
            </div>
            <a
              href="https://swaraya.ai"
              target="_blank"
              rel="noopener noreferrer"
              className="footer-powered-by"
              aria-label="Powered by Swaraya"
              data-testid="footer-powered-by"
            >
              <span className="footer-powered-label">powered by</span>
              <img loading="lazy" src="/images/swaraya-logo.png" alt="Swaraya" className="footer-powered-logo" />
            </a>
          </div>
        </div>
      </div>
      <LegalModal open={legalOpen} onClose={() => setLegalOpen(false)} initialTab={legalTab} />
    </footer>
  );
}
